import { combineReducers } from '@reduxjs/toolkit';
import actionSlice from './slices/action';
import propertySlice from './slices/propertyData';


export default combineReducers({
	actionSlice,
	propertySlice
})